export default [
  { value: 'ORDER', label: 'Order' },
  { value: 'ORDER_CAPTURE', label: 'Order Capture' },
  { value: 'REFUND', label: 'Refund' },
  { value: 'OTHERS', label: 'Others' },
];
